module.exports = __webpack_public_path__ + "staticfr/media/marcass.5f8c5d24.jpg";